import { useState } from 'react';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import './styles/degree-info-style.css';
import { Col, Container, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { generateColors } from '../../../../../utils/colorUtilsClientInfo';
import UniversityIcon from '../../../../../assets/images/ic_phd graduate.png';

const DegreeInfoPanel = ({ colorSeed, pgData }) => {
  const [viewDetails, setViewDetails] = useState(false);

  const colours = generateColors(colorSeed);
  return (
    <Container className='degreeInfoPanel'>
      <Row className="degreeInfoContainer mt-1 d-flex ">
        {/* University Icon */}
        <Col xs={2} sm={2} lg={1} className="d-flex justify-content-center ">
          <span className="rounded-span" style={{ backgroundColor: colours.backgroundColor, color: colours.color }}>
            <img src={UniversityIcon} alt="University Icon" />
          </span>
        </Col>

        {/* Degree Content */}
        <Col xs={8} sm={8} lg={9} className="degreeContent">
          <Row>
            <Col xs={12}>
              <span className="title">{_.get(pgData, 'degree')}</span>
              <span className="sub-title"> at {_.get(pgData, 'universityOrCollege')}</span>
            </Col>
          </Row>
          <Row>
            {_.get(pgData, 'universityCollegeDetails.startYear') && _.get(pgData, 'universityCollegeDetails.endYear') && (
              <Col xs={12}>
                <span className="sub-title1">
                  {_.get(pgData, 'universityCollegeDetails.startYear')} to{' '}
                  {_.get(pgData, 'universityCollegeDetails.endYear')}
                </span>
              </Col>
            )}

          </Row>
        </Col>
        {(_.get(pgData, 'universityCollegeDetails.cgpa') || _.get(pgData, 'universityCollegeDetails.percentage')) && (

          <Col xs={2} sm={2} lg={2} className="d-flex align-items-start justify-content-end viewDetailsContainer">
            <a
              className="viewDetailsToggle"
              onClick={(e) => {
                e.preventDefault();
                setViewDetails(!viewDetails);
              }}
            >
              <span className="viewMoreText-Ed">
                {viewDetails ? 'View Less' : 'View Details'}
              </span>
              <FontAwesomeIcon
                icon={viewDetails ? faChevronUp : faChevronDown}
                className="viewMoreIcon"
              />          </a>
          </Col>
        )}
      </Row>
      {/* Expanded Details */}
      {viewDetails && (
        <Row
          className={`p-1 mt-1 expandedDetails  pt-2 ${viewDetails && 'd-flex justify-content-center align-items-center'
            }`}
        >
          <Col lg={1}>&nbsp;</Col>

          <Col lg={9} md={8} xs={8}>
            <Row>
              <Col lg={12} >

                <p className='cgpa-container'>CGPA/Percentage: {''}
                  <span className="cgpa">{_.get(pgData, 'universityCollegeDetails.cgpa')}</span>
                </p>
              </Col>
            </Row>
          </Col>
          <Col lg={2} className="d-flex align-items-center justify-content-center">
            &nbsp;
          </Col>
        </Row>
      )}
    </Container>

  );
};

export default DegreeInfoPanel;